module.exports = __webpack_public_path__ + "img/whatsapp.b65e7fbc.svg";